import { MapLegend as Legend } from 'ui-components'

import { useIsEmbedding } from '~map-preview/hooks/useIsEmbedding'
import { useLegendTitle } from '~map-preview/hooks/useLegendTitle'

import { useInfographicLegend } from '~map-preview/states/infographic'
import { useLegend, useVisualisation } from '~map-preview/states/legend'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useIsMapLegendOpen } from '~map-preview/states/ui'

export const MapLegend = (props) => {
  const { setOpenDrawer, setSideBar } = useMapNavStore()

  const open = useIsMapLegendOpen()
  const visualisation = useVisualisation()

  const isInfographicLegend = useInfographicLegend()
  const isEmbed = useIsEmbedding()

  const title = useLegendTitle()
  const legend = useLegend()

  const handleExpandClick = () => {
    setOpenDrawer(true)
    setSideBar('legend')
  }

  if (!open) return null

  if (isEmbed) return null

  if (!isInfographicLegend) return null

  if (legend.length === 0) return null

  return (
    <Legend
      {...props}
      visualisation={visualisation}
      title={title}
      legend={legend}
      onExpandClick={handleExpandClick}
    />
  )
}
